import {sessionResourceTooltipMessages} from '../constants';

export const getAccessibleToStudentsTooltip = (isAvailableToStudents: boolean): string =>
  isAvailableToStudents
    ? sessionResourceTooltipMessages.accessibleToStudents
    : sessionResourceTooltipMessages.notAccessibleToStudents;
